import React, { useMemo, useCallback } from 'react'
import t from '~t'
import { useDispatch, useSelector } from 'react-redux'
import { selectAll } from '~data/actions/bookmarks'
import { makeStatus } from '~data/selectors/bookmarks'

import CollectionIcon from '~co/collections/item/icon'
import { HeaderFirstAction as FirstAction, Button } from '~ui'

const BookmarksHeaderIcon = React.memo(function BookmarksHeaderIcon({
    spaceId = 0,
    collection = {}
}) {
    const dispatch = useDispatch()
    const getStatus = useMemo(() => makeStatus(), [])
    const status = useSelector(state => getStatus(state, spaceId))

    const onSelectAllClick = useCallback(() => {
        dispatch(selectAll(spaceId))
    }, [dispatch, spaceId])

    const { _id, cover = [], access = {} } = collection
    const { level } = access
    const selectable = level >= 3 && status.main == 'loaded'
    const noicon = !cover.length && _id > 0

    if (noicon && !selectable) return null

    return (
        <FirstAction>
            <Button
                variant='ghost'
                className={'ui-bm-hdr-icon-btn'}
                data-selectable={selectable}
                onClick={selectable ? onSelectAllClick : undefined}>
                <CollectionIcon
                    className={'ui-bm-hdr-icon'}
                    _id={_id}
                    cover={cover}
                    loading={status.main == 'loading'} />

                {selectable && (
                    <label
                        className={'ui-bm-hdr-select'}
                        title={t.s('selectAll')}>
                        <input
                            tabIndex='-1'
                            type='checkbox' />
                    </label>
                )}
            </Button>
        </FirstAction>
    )
})

export default BookmarksHeaderIcon
